module.exports = __webpack_public_path__ + "media/images/icons/medal-be241a228f4177a3732d6e582ad88a65.svg";